module.exports = __webpack_public_path__ + "media/gateway/cvv-tarjeta-1-a170e1b9.png";